import { fg } from '@atlassian/jira-feature-gating';

const JsmWfoAssigneeRecommendationOnQueuesRelayprovider = {
	get(): boolean {
		return fg('jsm-wfo-assignee-recommendation-on-queues');
	},
};

export default JsmWfoAssigneeRecommendationOnQueuesRelayprovider;
